import { JsonLd, productNode, siteOrigin } from '@/lib/structuredData';

// schema.org JSON-LD for the homepage: Organization, Product + Offer per Bears card, FAQPage.
export const StructuredData = ({ products, faqs }) => {
  const origin = siteOrigin();
  return (
    <JsonLd
      data={{
        '@context': 'https://schema.org',
        '@graph': [
          { '@type': 'Organization', name: 'Blissful Play', url: origin },
          ...products.map((p) => productNode(p, origin)),
          {
            '@type': 'FAQPage',
            mainEntity: faqs.map((f) => ({
              '@type': 'Question',
              name: f.question,
              acceptedAnswer: { '@type': 'Answer', text: f.answer },
            })),
          },
        ],
      }}
    />
  );
};
